function App() {

  return (    
    <div className='App'>
      <h1>WORK IN PROGRESS - 2026</h1>
    </div>
  );
}


export default App;
